import React, { Component } from 'react'
import { RadioButton } from 'loyal-react'
import PropTypes from 'prop-types'

import '@loyal_template/recharge.css'

class ValuesRecharge extends Component {
  constructor (props) {
    super(props)

    this.onChangeValue = this.onChangeValue.bind(this)
  }

  componentDidMount () {
    this.props.getValuesRecharge(this.props.operatorKey, this.props.areaCode)
  }

  componentDidUpdate (prevProps) {
    if (
      (this.props.operatorKey !== prevProps.operatorKey &&
        this.props.operatorKey !== '') ||
      (this.props.areaCode !== prevProps.areaCode && this.props.areaCode !== '')
    ) {
      this.props.getValuesRecharge(this.props.operatorKey, this.props.areaCode)
    }
  }

  onChangeValue (serviceId, pointsValue, rechargeValue) {
    this.props.onChangeValue({
      value: serviceId,
      pointsValue: pointsValue,
      rechargeValue: rechargeValue
    })
  }

  render () {
    var valuesRecharge = []
    this.props.valuesRecharge.map(item => {
      valuesRecharge.push(
        <div className='col-4 col-md-2 col-lg-2 mt-6 mb-1 radius'>
          <label htmlFor='inputRecarga'>
            <RadioButton
              name='inputRecarga'
              id={`radio${item.serviceId}`}
              className='d-none'
              hidden='true'
              value={item.serviceId}
              defaultChecked={item.serviceId === this.props.valueSelected}
            />
            <p
              id={`btn${item.serviceId}`}
              name={'botaoRecarga'}
              className={`d-block radius  pointer border px-1 py-2 txt-body-sm txt-center ${
                item.serviceId === this.props.valueSelected
                  ? 'border-color-brand-1 color-brand-1 bg-ui-4'
                  : 'border-color-ui-2'
              }`}
              onClick={e =>
                this.onChangeValue(
                  item.serviceId,
                  item.pointsValue,
                  item.rechargeValue
                )
              }
            >
              {item.serviceId === this.props.valueSelected
                ? <strong className='txt-initial'>R$ {item.rechargeValue}</strong>
                : <span className='txt-initial'>R$ {item.rechargeValue}</span>}
            </p>
          </label>
        </div>
      )
    })
    return (
      <div>
        <div className='col-md-12 col-lg-12 txt-title-3 txt-body-sm txt-font-body txt-left mt-2 color-ui-2 px-0 mb-1'>
          Escolha o valor em créditos
        </div>
        <div className='col-md-6 col-lg-12 mt-0 px-0'>
          <div className='row'>{valuesRecharge}</div>
        </div>
      </div>
    )
  }
}

ValuesRecharge.propTypes = {
  valuesRecharge: PropTypes.array,
  areaCode: PropTypes.number.isRequired,
  operatorKey: PropTypes.string,
  getValuesRecharge: PropTypes.func,
  onChangeValue: PropTypes.func,
  valueSelected: PropTypes.string
}
export default ValuesRecharge



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ValuesRecharge/ValuesRecharge.js